import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import { AppBar, Toolbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Dosen from "./guru.png";
// import Img1 from "./img_avatar.png";
import Boot from "./bootstrap.jpeg";
import Fire from "./firebase.png";
import Material from "./material.png";
import Rct from "./reactjs.png";
const Informasi = () => {
	let history = useHistory();
	const useStyles = makeStyles((theme) => ({
		appbar: {
			background: "rgba(75,178,115,0.9)",
		},
		wrapper: {
			width: "85%",
			margin: "0 auto",
			display: "flex",
			justifyContent: "space-between",
		},
	}));
	const classes = useStyles();
	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])
	const [ukuranP, setUkuranP]=useState(14);
	const [ukuranH, setUkuranH]=useState(18);
	const sizeplus = () =>{
		setUkuranP(ukuranP + 1)
		setUkuranH(ukuranH + 1)
	}
	const sizemin = () =>{
		setUkuranP(ukuranP - 1)
		setUkuranH(ukuranH - 1)
	}

	return (
		<div>
			<AppBar className={classes.appbar}>
				<Toolbar className={classes.wrapper}>
					<h4>Program Linear</h4>
				</Toolbar>
			</AppBar>

			<div className="container mt-5">
			<div className="d-flex justify-content-end mt-3">
			<button className="btnplus" 
			onClick={sizeplus}><h4>+</h4></button>
				<button className="btnplus" onClick={sizemin}><h4>-</h4></button>
			</div>		
				<div className="d-flex justify-content-center py-4 mt-2">
					<div className="card border-success shadow  bg-body rounded ">
						<div
							style={{ color: "white" }}
							className="card-header bg-success text-center"
						>
							<h3>Informasi</h3>
						</div>
						<div className="card-body text-secondary">
							<div style={{fontSize:`${ukuranH}px` , color: "#40bf80"}} className="text-center mt-2">
								Informasi Author
							</div>
							<div style={{ display: "flex", justifyContent: "center" }}>
								<hr
									style={{ width: "90%", height: "4px", color: "green" }}
								></hr>
							</div>
							<div className="card-tittle">
								<div className="py-3">
									<p style={{fontSize:`${ukuranH}px`}} className="text-center mb-3 ">
										Media Pembelajaran ini dibuat untuk memenuhi persyaratan
										dalam menyelesaikan Program Strata-1 Pendidikan Komputer
										dengan judul tugas akhir
									</p>

									<p style={{fontSize:`${ukuranP}px`}}  className="text-center">
										Pengembangan Media Pembelajaran Interaktif Berbasis Web pada
										Materi Program Linear Dua Variabel Kelas XI dengan Metode
										Drill and Practice
									</p>
								</div>
								<div className="d-flex justify-content-center">
									<div
										className="card shadow bg-body rounded mt-2"
										style={{ width: "19rem" }}
									>
										<div className="card-body">
											<h6 className="card-title text-center">
												Renaldi Al Amin
											</h6>
										</div>
										<div className="card-text">
											<ul>
												<li>1710131310037</li>
												<li>aldirenaldialamin@gmail.com</li>
												<li>Pendidikan Ilmu Komputer</li>
												<li>Fakultas Keguruan dan Ilmu Pendidikan</li>
												<li>Universitas Lambung Mangkurat</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="text-center h4 mt-4 mb-3">Dosen Pembimbing</div>
								<div className="row">
									<div className="col-sm-12 col-lg-3 offset-lg-3 col-md-4" style={{marginRight:"2rem"}}>
										<div
											className="card shadow bg-body rounded"
											style={{ width: "13rem" }}
										>
											<img src={Dosen} className="card-img-top" alt="Img1" />
											<div className="card-body">
												<h6 className="card-title">
													Dr. R. Ati Sukmawati, M.Kom.
												</h6>
											</div>
											<div className="card-text">
												<ul>
													<li style={{fontSize:`${ukuranP}px`}}>Pembimbing 1</li>
												</ul>
											</div>
										</div>
									</div>
									<div className="col-sm-12  col-lg-3 col-md-4">
										<div
											className="card shadow bg-body rounded"
											style={{ width: "13rem" }}
										>
											<img src={Dosen} className="card-img-top" alt="Img1" />
											<div className="card-body">
												<h6 className="card-title">Yuni Suryaningsih, M.Pd</h6>
											</div>
											<div className="card-text">
												<ul>
													<li style={{fontSize:`${ukuranP}px`}}>Pembimbing 2</li>
												</ul>
											</div>
										</div>
									</div>
								</div>

								<div
									className="h5 text-center mt-5"
									style={{ color: "#40bf80", fontSize:`${ukuranH}px` }}
								>
									Informasi Media
								</div>
								<div style={{ display: "flex", justifyContent: "center" }}>
									<hr
										style={{ width: "90%", height: "4px", color: "green" }}
									></hr>
								</div>
								<p style={{fontSize:`${ukuranP}px`}} className="text-center">Media pembelajaran ini berisi materi Program Linear untuk siswa kelas 11 SMA/MAN.
								 Dalam media pembelajaran ini terdapat berupa penyajian materi, contoh soal, soal latihan, dan mari mencoba berupa pertanyaan dan kuis secara interaktif dan menarik.</p>
								
								<div className="text-center h6 mt-1 mb-4">Teknologi yang digunakan</div>
								<div className="d-flex justify-content-lg-center justify-content-sm-start ">
									<img
										src={Rct}
										style={{ width: "80px", height: "80px"}}
										alt="1"
									/>
										<img
											src={Fire}
											style={{ width: "80px", height: "80px", marginLeft:'5px', marginRight:'5px' }}
											alt="1"
										/>
									<img
										src={Boot}
										style={{ width: "80px", height: "80px", marginRight:'10px' }}
										alt="1"
									/>
									<img
										src={Material}
										style={{ width: "80px", height: "80px", marginLeft:'10px'}}
										alt="1"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="d-flex justify-content-center">
					<button
						onClick={() => history.goBack()}
						className="btn btn-outline-success mb-3"
					>
						Kembali
					</button>
				</div>
			</div>
		</div>
	);
};

export default Informasi;
